import { VisualNavigation } from '../../components';
import type { VisualNavigationProps } from '../../components/Tile6Up/types';
import { BuildContextProvider } from '../../providers';

export function VisualNavigationSection({ tiles }: VisualNavigationProps) {
    return (
        <BuildContextProvider>
            <VisualNavigation variant="VisualNav" tiles={tiles} />
        </BuildContextProvider>
    );
}
